export const POSTHOG_SIGNUP_EVENT_WEB_CHAT = 'signup:web_chat';
export const POSTHOG_SIGNUP_EVENT_FB_MESSENGER = 'signup:messenger';
export const POSTHOG_SIGNUP_EVENT_IMESSAGE = 'signup:apple_messages';
export const POSTHOG_SIGNUP_EVENT_INSTA = 'signup:instagram';
export const POSTHOG_SIGNUP_EVENT_SMS = 'signup:sms';
export const POSTHOG_SIGNUP_EVENT_TELEGRAM = 'signup:telegram';
export const POSTHOG_SIGNIN_EVENT = 'signin:attempt';
export const POSTHOG_SIGNIN_EMAIL_EVENT = 'signin:email_attempt';
export const POSTHOG_SIGNIN_EMAIL_RESULT_EVENT = 'signin:email_result';

/** How the user arrived at a sign-in attempt. */
export const SIGNIN_ENTRY_MAGIC_LINK = 'magic_link';
export const SIGNIN_ENTRY_MANUAL = 'manual';
export const POSTHOG_SEND_CHAT_MESSAGE_EVENT = 'chat:send_message';
export const POSTHOG_DONATION_EVENT_RECURRING = 'premium:subscription_start';
export const POSTHOG_DONATION_EVENT_ONETIME = 'coins:purchase';
/**
 * Click on a link out to the Stripe donation page, carrying a `placement`
 * property so the hero, body and footer asks can be told apart.
 *
 * Named for what it is. The two constants above are on-site coin and
 * membership purchases despite being called DONATION events, and neither has
 * anything to do with donating.
 */
export const POSTHOG_DONATE_CLICK_EVENT = 'donate:click';
